module.exports = __webpack_public_path__ + "static/media/icons.f78ceeb2.svg";